import z from 'zod';
import { groupDataSchema, companyDataSchema, groupSchema, groupsApiResponseSchema, groupListSchema } from './schemas';

export type GroupData = z.infer<typeof groupDataSchema>;

export type CompanyData = z.infer<typeof companyDataSchema>;

export type Group = z.infer<typeof groupSchema>;

export type GroupsApiResponse = z.infer<typeof groupsApiResponseSchema>;

export const GROUP_CONTACT_TYPES = [
	'General (office phone/mail)',
	'In Case of Emergency Contact',
	'Prevention Advisor',
	'Safety Supervisor',
	'Company Doctor',
	'Commercial Contact',
	'Operational SPOC',
] as const;

// Create a type from the array
export type GroupContactType = (typeof GROUP_CONTACT_TYPES)[number];
export type GroupList = z.infer<typeof groupListSchema>;
export type GroupContact = {
	id?: string;
	type?: string;
	name?: string;
	email?: string;
	phone?: string;
};
